import {ClientBookmarkConvertResponse} from "../../infra/api/service/client_bookmark_api_convert";

export class ClientBookmark {
    public static from(from: ClientBookmarkConvertResponse): ClientBookmark {
        return new ClientBookmark(
            from.clientID,
            from.customerID,
            from.createdAt,
        )
    }

    constructor(public readonly clientID: string,
                public readonly customerID: string,
                public readonly createdAt: Date,) {

    }
}


// WEBPACK FOOTER //
// ./src/domain/model/client_bookmark.ts